const ORDER_TYPE = {
  ADMIN: 0,
  SUPPLIER: 1,
  WEBSHOP: 2,
  CREDIT: 3,
  PREORDER: 4
}

export { ORDER_TYPE }